var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.3671 21.5189V11H20.4638L20.4638 21.5514L15 16.0216L13 18L21.8832 27L30.829 18L28.829 16.0216L23.3671 21.5189ZM29.9141 29H13.9141V32H29.9141V29Z","fill":"black","key":1})]);
}

Download.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Download;

Download.default = Download;
